export default {"src":"/_next/static/media/subjectNew.de5bfcd6.svg","height":97,"width":89,"blurWidth":0,"blurHeight":0};